import { render, staticRenderFns } from "./brandDialog.vue?vue&type=template&id=a4fbc47a&scoped=true"
import script from "./brandDialog.vue?vue&type=script&lang=js"
export * from "./brandDialog.vue?vue&type=script&lang=js"
import style0 from "./brandDialog.vue?vue&type=style&index=0&id=a4fbc47a&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4fbc47a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src881454487/src/clients/ap3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a4fbc47a')) {
      api.createRecord('a4fbc47a', component.options)
    } else {
      api.reload('a4fbc47a', component.options)
    }
    module.hot.accept("./brandDialog.vue?vue&type=template&id=a4fbc47a&scoped=true", function () {
      api.rerender('a4fbc47a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/sectors/brandDialog.vue"
export default component.exports